import { ClientSideTable } from 'Presentation/Components/Table'
import PileInput from './PileInput'

interface Props {
  isView: boolean
  data: any[]
  onChange: (itemId: number, field: string, value: any) => void
}

const Pile: React.FC<Props> = ({ isView, data, onChange }) => {
  const TABLE_CONFIGS = [
    {
      Header: 'No.',
      accessor: 'id',
      width: 25,
      minWidth: 25,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'รหัสเสา',
      accessor: 'itemCode',
      width: 80,
      minWidth: 80,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'ชื่อเสา',
      accessor: 'itemTitle',
      width: 80,
      minWidth: 80,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'จำนวนเสา',
      accessor: 'quantity',
      width: 80,
      minWidth: 80,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'Safe Load',
      accessor: 'safeLoad',
      width: 80,
      minWidth: 80,
      onChange,
      field: 'safeLoad',
      isView: isView,
      Cell: PileInput,
    },
    {
      Header: 'FS.',
      accessor: 'ps',
      width: 80,
      minWidth: 80,
      onChange,
      field: 'ps',
      isView: isView,
      Cell: PileInput,
    },
  ]

  return (
    <div className='card' style={{display:"none"}}>
      <div className='card-header'>
        <div className='card-title fw-bold'>รายการเสาเข็ม</div>
      </div>

      <div className='card-body'>
        <ClientSideTable data={data} columns={TABLE_CONFIGS} items_per_page={10} />
      </div>
    </div>
  )
}

export default Pile
